// Téléchargement authentifié d'un document protégé (ANO-ECC-04) — envoie le Bearer, ouvre le blob.
export async function openProtectedDoc(backend, path, token) {
  try {
    const res = await fetch(`${backend}${path}`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
    if (!res.ok) return false;
    const blob = await res.blob();
    window.open(URL.createObjectURL(blob), '_blank');
    return true;
  } catch {
    return false;
  }
}

// Autorisation : jeton `t` (lien e-mail) OU session propriétaire/admin (Bearer).
export async function fetchDocLinks(backend, quoteId, { t, token } = {}) {
  try {
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    const url = `${backend}/api/devis/${quoteId}/doc-links` + (t ? `?t=${encodeURIComponent(t)}` : '');
    const res = await fetch(url, { headers });
    if (!res.ok) return null;
    return await res.json();
  } catch {
    return null;
  }
}
